// =============================================================================
// app/src/lib/jogo.ts — quantas peças tem o jogo (08/10/2026).
//
// Pedido do dono: "queria que quando o cara colocasse uma calota desse a
// oportunidade de clicar em um botão que aparece JOGO em que ele clica e coloca
// 4 unidades".
//
// POR QUE ISTO EXISTE AGORA. Até 08/10/2026 a calota era vendida EM JOGO: a
// unidade era 'JG' e o preço cadastrado era o do jogo de quatro. Nesse dia o
// dono mandou passar tudo para PEÇA — o estoque foi multiplicado por 4 (86 para
// 344) e o preço dividido por 4. A conta do cliente não mudou: quatro peças
// custam o que o jogo custava. O que mudou foi o gesto do balcão, e ele é
// perigoso: quem leva o jogo completo depende de o vendedor digitar 4, e se ele
// deixar 1 a loja cobra um quarto. Este botão é o que devolve o toque único.
//
// POR QUE O NÚMERO MORA AQUI, E NÃO NO BANCO. Porque o dono respondeu "só
// calota, por enquanto" quando perguntado se a lâmpada e a palheta (que ele
// vende em par) também ganhariam o botão. Com um tipo só, uma coluna
// `unidades_por_jogo` em `part_types` custaria migração, APPLY e coordenação de
// deploy para guardar um dígito. No dia em que for mais de um, o número vira
// DADO: esta tabela sai daqui e vira coluna, e o ponto de leitura é um só —
// `unidadesDoJogo`.
//
// A CHAVE É O `tipo` (part_types, migração 092), nunca a categoria, a unidade
// ou o nome:
//   * `categoria` é texto livre, sem check, e já derivou — foi exatamente o
//     problema que a 092 nasceu para resolver (as calotas moravam em
//     "ACESSÓRIOS"), e deriva nela já custou R$ 29.412,30 no PR #231;
//   * `unidade` também é texto livre, e a própria mudança de 08/10 acabou de
//     tirar a calota de 'JG';
//   * o nome casaria "CALOTA ..." e perderia "JOGO DE CALOTA".
// `products.tipo` é FK para `part_types (slug)`: vocabulário controlado.
//
// E O PIOR CASO É O BOTÃO NÃO APARECER, nunca uma quantidade errada — se o
// slug mudar no banco e ninguém mexer aqui, o vendedor volta a digitar 4, que
// é o que ele faz hoje.
// =============================================================================

/** Quantas peças formam o jogo, por tipo de peça (`products.tipo`). Tipo que
 *  não está aqui se vende um a um, e não ganha botão. */
const UNIDADES_POR_JOGO: Readonly<Record<string, number>> = {
  calota: 4,
};

/**
 * Quantas peças tem o jogo desta peça — ou `null` quando ela não se vende em
 * jogo (que é a maioria), quando o tipo é desconhecido, ou quando a linha é
 * PEÇA DIVERSA (texto livre, sem tipo).
 *
 * Devolver `null` em vez de 1 é deliberado: 1 é uma quantidade válida, e quem
 * chama precisa distinguir "não tem jogo" de "o jogo é de uma peça".
 */
export function unidadesDoJogo(tipo: string | null | undefined): number | null {
  if (!tipo) return null;
  return UNIDADES_POR_JOGO[tipo] ?? null;
}
